import React, { useState, useEffect } from 'react'
import './newsletter.css';
import '../examinations/result.css';
import { Form, InputGroup, Button, Tabs, Tab } from 'react-bootstrap';
import { Download as DownloadIcon, Search } from 'react-feather';

import { useQuery, gql } from '@apollo/client';

const GET_NEWSLETTERS = gql`
  query {
    newsletters {
      data {
        attributes {
          year
          newsletters {
            title
            newsletter {
              data {
                attributes {
                  url
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

function Newsletter() {
  const newsletterData = useQuery(GET_NEWSLETTERS);
  const newsletters = newsletterData?.data;
  const [searchTerm, setSearchTerm] = useState('');
  const [activeYear, setActiveYear] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 9;

  // Build years list and map of files by year
  const items = (newsletters?.newsletters?.data || []).map(n => ({
    year: n?.attributes?.year,
    files: n?.attributes?.newsletters || []
  }));
  const years = items.map(i => i.year).filter(Boolean).sort().reverse();

  useEffect(() => {
    if (years.length > 0 && !activeYear) {
      setActiveYear(years[0]);
    }
  }, [years, activeYear]);

  // Reset page on search or year change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, activeYear]);

  return (
    <div className="results-dashboard">
      {/* Header Banner */}
      <div
        className="main-banner"
        style={{
          background: 'url(./images/banner/banner1.png) center top',
        }}
      >
        <div className="container px-md-0">
          <h2>
            <span>News Letter</span>
          </h2>
        </div>
      </div>

      <div className="breadcrumb">
        <div className="container px-md-0">
          <ul className="list-unstyled list-inline">
            <li className="list-inline-item">
              <a href="/home">Home</a>
            </li>
            <li className="list-inline-item active">Newsletters</li>
          </ul>
        </div>
      </div>

      <div className="container py-4">
        {/* Search */}
        <div className="search-container mb-4">
          <Form onSubmit={(e) => e.preventDefault()}>
            <InputGroup className="search-input-group">
              <InputGroup.Text className="search-icon">
                <Search size={18} />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search newsletters by title or year..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
              {searchTerm && (
                <Button
                  variant="outline-secondary"
                  onClick={() => setSearchTerm('')}
                  className="clear-search"
                >
                  Clear
                </Button>
              )}
            </InputGroup>
          </Form>
        </div>

        {/* Year Tabs (like Syllabus) */}
        {years.length > 0 && (
          <Tabs
            activeKey={activeYear}
            onSelect={(y) => setActiveYear(y)}
            className="mb-4 year-tabs"
            variant="pills"
          >
            {years.map((y) => (
              <Tab key={y} eventKey={y} title={`${y}`} />
            ))}
          </Tabs>
        )}

        {/* Grid for active year */}
        {activeYear && (
          <div className="mb-4">
            <h3 className="mb-3">{activeYear}</h3>
            <div className="results-grid">
              {items
                .filter(i => i.year === activeYear)
                .flatMap(i => i.files)
                .filter((file) => {
                  const s = searchTerm.toLowerCase();
                  const title = (file?.title || '').toLowerCase();
                  return !searchTerm || title.includes(s) || String(activeYear).includes(s);
                })
                .slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE)
                .map((file, idx) => (
                  <div key={idx} className="result-card">
                    <div className="card-icon">
                      <DownloadIcon size={20} />
                    </div>
                    <div className="card-content">
                      <h3>{file?.title || 'Newsletter'}</h3>
                      <div className="card-meta">
                        <span className="meta-item">Year: {activeYear}</span>
                      </div>
                    </div>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${process.env.REACT_APP_API_URL}${file?.newsletter?.data?.attributes?.url}`}
                      className="download-btn"
                      download
                    >
                      <DownloadIcon size={16} className="me-1" /> Download
                    </a>
                  </div>
                ))}
            </div>
            {/* Pagination */}
            {(() => {
              const total = items
                .filter(i => i.year === activeYear)
                .flatMap(i => i.files)
                .filter((file) => {
                  const s = searchTerm.toLowerCase();
                  const title = (file?.title || '').toLowerCase();
                  return !searchTerm || title.includes(s) || String(activeYear).includes(s);
                }).length;
              const totalPages = Math.ceil(total / ITEMS_PER_PAGE);
              if (totalPages <= 1) return null;
              return (
                <div className="pagination-container mt-4">
                  <button
                    className="btn btn-outline-primary pagination-btn"
                    onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  <div className="page-info">Page {currentPage} of {totalPages}</div>
                  <button
                    className="btn btn-outline-primary pagination-btn"
                    onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              );
            })()}
          </div>
        )}
      </div>
    </div>
  );
}
export default Newsletter;
